import { render } from "./Pill.vue?vue&type=template&id=24a5810b&scoped=true&ts=true"
import script from "./Pill.vue?vue&type=script&lang=ts"
export * from "./Pill.vue?vue&type=script&lang=ts"

import "./Pill.vue?vue&type=style&index=0&id=24a5810b&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a5810b"]])

export default __exports__